module.exports = __webpack_public_path__ + "img/cnc-03-land-area.2251904c.svg";